import {
  Municipality,
  MunicipalitySearch,
} from '@ta-interaktiv/react-municipality-search'
import Button from 'components/Button/Button'
import styled from 'styled-components'

export default ({
  correctMunicipality,
  setCorrectMunicipality,
  isActive,
}: {
  correctMunicipality: Municipality | null
  setCorrectMunicipality: (municipality: Municipality | null) => void
  isActive?: boolean
}) => {
  return (
    <LocationCorrectorWrapper isActive={isActive}>
      <Title>Stimmt es nicht?</Title>
      <Description>
        Bitte geben Sie den von Ihnen erwarteten Ort an, damit wir das Tool in
        Zukunft verbessern können:
      </Description>
    
        <MunicipalitySearch
          dedupe
          resetOnSelect
          municipalityData='20230101_de_nozip'
          selectedMunicipality={correctMunicipality || undefined}
          onCloseHandler={()=>setCorrectMunicipality(null)}
          resultBackgroundColor='var(--site-background)'
          onSelectionHandler={(municipality) => {
            console.log(municipality)
            setCorrectMunicipality(municipality)
          }}
        />
    </LocationCorrectorWrapper>
  )
}
const Title = styled.h5`
  font-size: 1.5em;

  margin-bottom: 0.25em;
  text-align: center;
`
const Description = styled.p`
  font-size: 0.8em;
  line-height: 1.3;
  padding: 0 1em;
  margin-top: 0.5em;
  max-width: 500px;
  text-align: center;
  @media (min-width: 600px) {
    font-size: 0.7em;
  }
`

const LocationCorrectorWrapper = styled.div<{ isActive?: boolean }>`
  ${({ isActive }) => (isActive ? '' : 'opacity: 0; pointer-events: none;')}
  font-size: var(--small-text-size);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 175px;
  transition: opacity 1s ease-in-out;
  margin-bottom: 2em;
  padding: 0 1em;
  .results{
    z-index: 2;
  }
`
const SelectedMunicipality = styled(Button)`
  background-color: var(--button-background);
  color: white;
  border-radius: 0.5em;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.25);

  svg {
    transition: all 0.3s ease;
    max-width: 1em;
    padding-right: 0.2em;
    stroke: currentColor;
  }
  &:hover {
    svg {
      stroke: var(--yellow-main) !important;
      stroke-width: 3 !important;
    }
  }
  :disabled {
    opacity: 0;
    pointer-events: none;
  }
`
